import { render, staticRenderFns } from "./MyPageCompetition.vue?vue&type=template&id=28c4ec0b&scoped=true"
import script from "./MyPageCompetition.vue?vue&type=script&lang=js"
export * from "./MyPageCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4ec0b",
  null
  
)

export default component.exports